import React from 'react'
import {Alert, AlertTitle} from '@material-ui/lab'

const ScheduleNotAvailable = () => (
    <Alert severity="error">
        <AlertTitle>Error. </AlertTitle>
        Service is not available in your state
    </Alert>
);

export default ScheduleNotAvailable
